import { GetInstitutionRequest } from './institutions/getInstitution/getInstitution.types';
import { GetInstitutionsRequest } from './institutions/getInstitutions/getInstitutions.types';
import { GetInstitutionsPublicRequest } from './institutions/getInstitutionsPublic/getInstitutionsPublic.types';
import { GetInstitutionStaffRolesRequest } from './institutionStaffRoles/getInstitutionStaffRoles/getInstitutionStaffRoles.types';
import { GetLeadsRequest } from './leads/getLeads/getLeads.types';
import { GetShalhavotDashboardRequest } from './leads/getLeadsDashboard/getShalhavotDashboard.types';
import { GetKindergartenDashboardRequest } from './leads/getLeadsDashboard/getKindergartenDashboard.types';
import { GetDaycareCentersDashboardRequest } from './leads/getLeadsDashboard/getDaycareCentersDashboard.types';
import { GetStaffMemberInstitutionRolesRequest } from './staffMemberInstitutionRole/getStaffMemberInstitutionRoles/getStaffMemberInstitutionRoles.types';
import { GetStaffMemberRequest } from './staffMembers/getStaffMember/getStaffMember.types';
import { GetStaffMembersWithDetailsParams } from './staffMembers/getStaffMembersWithDetails/getStaffMembersWithDetails.types';
import { GetTagsRequest } from './tags/getTags/getTags.types';
import { GetOperationsRequest } from './operations/getOperations/getOperations.types';
import { GetGrantRequestsRequest } from './grantFund/getGrantRequests/getGrantRequests.types';
import { GetGrantSubmissionsRequest } from './grantFund/getGrantSubmissions/getGrantSubmissions.types';
import { GetLoanRequestsRequest } from './loans/getLoanRequests/getLoanRequests.types';
import { GetLoanSubmissionsRequest } from './loans/getLoanSubmissions/getLoanSubmissions.types';
import { GetSupportRequestsRequest } from './supports/getSupportRequests/getSupportRequests.types';
import { GetSupportSubmissionsRequest } from './supports/getSupportSubmissions/getSupportSubmissions.types';

export const cacheKeys = {
  // Institution cache keys
  getInstitutions: (request?: GetInstitutionsRequest) => ['getInstitutions', request].filter(k => k),
  getInstitution: (request?: GetInstitutionRequest) => ['getInstitution', request].filter(k => k),
  getInstitutionsPublic: (request?: GetInstitutionsPublicRequest) => ['getInstitutionsPublic', request].filter(k => k),
  canManageInstitution: (id?: number) => ['institution', id].filter(k => k),

  // Leads cache keys
  getLeads: (request?: GetLeadsRequest) => ['getLeads', request].filter(k => k),
  getShalhavotDashboard: (request?: GetShalhavotDashboardRequest) => ['getShalhavotDashboard', request].filter(k => k),
  getKindergartenDashboard: (request?: GetKindergartenDashboardRequest) => ['getKindergartenDashboard', request].filter(k => k),
  getDaycareCentersDashboard: (request?: GetDaycareCentersDashboardRequest) => ['getDaycareCentersDashboard', request].filter(k => k),
  getInstitutionsWithTargets: () => ['getInstitutionsWithTargets'],
  getKindergartenInstitutionsWithTargets: () => ['getKindergartenInstitutionsWithTargets'],
  getDaycareCentersInstitutionsWithTargets: () => ['getDaycareCentersInstitutionsWithTargets'],

  // Staff Member cache keys
  getStaffMember: (request?: GetStaffMemberRequest) => ['getStaffMember', request].filter(k => k),
  getStaffMembersWithDetails: (request?: GetStaffMembersWithDetailsParams) =>
    ['getStaffMembersWithDetails', request].filter(k => k),

  // Staff Member Institution Roles cache keys
  getStaffMemberInstitutionRoles: (request?: GetStaffMemberInstitutionRolesRequest) =>
    ['getStaffMemberInstitutionRoles', request].filter(k => k),

  // Institution Staff Roles cache keys
  getInstitutionStaffRoles: (request?: GetInstitutionStaffRolesRequest) =>
    ['getInstitutionStaffRoles', request].filter(k => k),

  // Tags cache keys
  getTags: (request?: GetTagsRequest) => ['getTags', request].filter(k => k),

  // Operations cache keys
  getOperations: (request?: GetOperationsRequest) => ['getOperations', request].filter(k => k),

  // Grant fund cache keys
  getGrantRequests: (request?: GetGrantRequestsRequest) =>
    ['getGrantRequests', request].filter(k => k),
  getGrantSubmissions: (request?: GetGrantSubmissionsRequest) =>
    ['getGrantSubmissions', request].filter(k => k),

  // Loans cache keys
  getLoanRequests: (request?: GetLoanRequestsRequest) =>
    ['getLoanRequests', request].filter(k => k),
  getLoanSubmissions: (request?: GetLoanSubmissionsRequest) =>
    ['getLoanSubmissions', request].filter(k => k),

  // Supports cache keys
  getSupportRequests: (request?: GetSupportRequestsRequest) =>
    ['getSupportRequests', request].filter(k => k),
  getSupportSubmissions: (request?: GetSupportSubmissionsRequest) =>
    ['getSupportSubmissions', request].filter(k => k),

  // Add other cache keys here
} as const;
